// src/i18n/en_US.ts
//
// Dicionário inglês do painel do estabelecimento, do login e do cadastro.
//
// A chave é o texto em PORTUGUÊS, igual ao que o backend faz com
// $translator->trans(). Duas consequências práticas:
//
//   - português não tem dicionário: a chave já é a tradução;
//   - chave sem entrada aqui cai no português em vez de aparecer quebrada,
//     então texto novo nunca derruba a tela — só fica sem traduzir.
//
// {chave} dentro do texto é interpolação: t("Olá, {nome}", { nome }).
// O placeholder precisa ser IDÊNTICO nos dois idiomas.
//
// 618 chaves.

export const en_US: Record<string, string> = {
  " por 3 meses": " for 3 months",
  "\"{nome}\" foi adicionado. Os documentos entraram em análise.": "\"{nome}\" was added. The documents are now under review.",
  "\"{nome}\" já está vinculado a outro usuário. Se este estabelecimento é seu,": "\"{nome}\" is already linked to another user. If this establishment is yours,",
  "(cópia)": "(copy)",
  "(opcional)": "(optional)",
  "+{n} de missões": "+{n} from missions",
  ", corrija e reenvie — não há limite de tentativas e o prazo contratado não é consumido enquanto isso.": ", fix it and resend — there's no limit on attempts, and your purchased run time isn't used up in the meantime.",
  ", mas você não precisa esperar — pode entrar e começar a usar agora.": ", but you don't have to wait — you can sign in and start using it now.",
  ", {n} falha(s)": ", {n} failed",
  ". Seus estabelecimentos já estão cadastrados e o painel segue liberado normalmente.": ". Your establishments are already registered and your dashboard stays fully available.",
  "/mês": "/mo",
  "15 dias de veiculação": "15 days of exposure",
  "3 meses grátis": "3 months free",
  "30 dias de veiculação": "30 days of exposure",
  "72 horas": "72 hours",
  "A cobrança no seu cartão começa a partir dessa data.": "Your card will be charged starting on that date.",
  "A gestão de banners promocionais é uma funcionalidade exclusiva dos planos": "Managing promotional banners is a feature exclusive to",
  "A imagem deve ter exatamente {w}x{h}px (a enviada tem {rw}x{rh}px).": "The image must be exactly {w}x{h}px (the one you uploaded is {rw}x{rh}px).",
  "A nova senha deve ter no mínimo 8 caracteres.": "The new password must be at least 8 characters.",
  "A selfie deve ter no máximo 10 MB.": "The selfie must be 10 MB or smaller.",
  "A senha deve ter no mínimo 8 caracteres.": "The password must be at least 8 characters.",
  "A área de banners desta unidade é liberada assim que a análise for concluída — o prazo é de até": "The banners area for this location unlocks as soon as the review is finished — it takes up to",
  "Abril": "April",
  "Acessar meu painel": "Go to my dashboard",
  "Acesse o portal de pagamentos para visualizar todas as suas faturas e histórico completo.": "Open the billing portal to see all your invoices and your full history.",
  "Adicionar estabelecimento": "Add establishment",
  "Adicionar imagem": "Add image",
  "Agosto": "August",
  "Aguardando aprovação": "Awaiting approval",
  "Agência": "Agency",
  "Ainda não há banners para serem exibidos.": "No banners to show yet.",
  "Ajustar": "Needs changes",
  "Alcance ainda maior para sua marca": "Even wider reach for your brand",
  "Alcance de 10 km": "10 km reach",
  "Alcance de 10 km a partir do seu endereço": "10 km reach from your address",
  "Alcance de 30 km": "30 km reach",
  "Alcance de 30 km a partir do seu endereço": "30 km reach from your address",
  "Alemão": "German",
  "Alterar senha": "Change password",
  "Anterior": "Previous",
  "Ao entrar, você será levado direto para a área de Assinatura para concluir a assinatura do plano {plano}.": "When you sign in, we'll take you straight to the Subscription area to finish subscribing to the {plano} plan.",
  "Ao entrar, você será redirecionado para concluir a assinatura do plano escolhido.": "When you sign in, we'll take you straight to finish subscribing to the plan you picked.",
  "Ao excluir sua conta, todos os seus dados serão permanentemente removidos. Sua assinatura também será cancelada.": "Deleting your account permanently removes all of your data. Your subscription will be canceled as well.",
  "Ao repostar este banner, as configurações e imagem serão reutilizadas. Tem certeza que deseja repostar este banner?": "Reposting reuses this banner's settings and image. Are you sure you want to repost it?",
  "Apelido": "Nickname",
  "Aprovado": "Approved",
  "Aprovados": "Approved",
  "Apto, Sala...": "Apt., Suite...",
  "Após o envio você será direcionado para cadastrar o cartão. Seus documentos serão analisados em até 72 horas.": "After you submit, we'll take you to add your card. Your documents will be reviewed within 72 hours.",
  "Arquivo muito pesado ({kb} KB). O limite é {max} KB.": "File too large ({kb} KB). The limit is {max} KB.",
  "Arquivos": "Files",
  "Arraste para o lado ou use a seta para ver todos os planos": "Swipe sideways or use the arrow to see every plan",
  "Arraste para o lado para ver todos os planos": "Swipe sideways to see every plan",
  "Arte": "Art",
  "Arte aprovada e no ar": "Artwork approved and live",
  "Arte aprovada pela nossa equipe em até 72h": "Artwork approved by our team within 72h",
  "Arte em análise.": "Artwork under review.",
  "Artes fora dessas regras são recusadas na análise, e você recebe o motivo por e-mail para reenviar. O prazo contratado só começa a contar após a aprovação.": "Artwork that breaks these rules is rejected in review, and we email you the reason so you can resubmit. The period you paid for only starts counting after approval.",
  "As notificações desta unidade são liberadas assim que a análise for concluída — o prazo é de até": "Notifications for this location unlock as soon as the review is finished — it takes up to",
  "As novas senhas não coincidem.": "The new passwords don't match.",
  "As senhas não coincidem.": "The passwords don't match.",
  "As áreas de": "The",
  "As áreas de Banners e Notificações Push abrem após a aprovação.": "The Banners and Push Notifications areas unlock once you're approved.",
  "As áreas de Banners e Notificações Push são liberadas após a aprovação.": "The Banners and Push Notifications areas unlock after approval.",
  "Assim que aprovada, ela entra na vitrine automaticamente — e só a partir desse momento começa a contar o prazo de veiculação que você contratou.": "Once approved, it goes live in the showcase automatically — and only from that point does the run time you purchased start counting.",
  "Assim que aprovada, ela entra na vitrine automaticamente.": "Once approved, it goes live in the showcase automatically.",
  "Assinar": "Subscribe",
  "Assinar {plano}": "Subscribe to {plano}",
  "Assinatura": "Subscription",
  "Assinatura confirmada!": "Subscription confirmed!",
  "Assine agora mesmo": "Subscribe now",
  "Assine um dos planos Pertalks e obtenha vantagens e benefícios para o seu estabelecimento.": "Subscribe to a Pertalks plan and unlock perks and benefits for your establishment.",
  "Assine um plano para visualizar os dados do seu estabelecimento.": "Subscribe to a plan to see your establishment's data.",
  "Assunto": "Subject",
  "Atendimento prioritário no WhatsApp:": "Priority support on WhatsApp:",
  "Atenção: trocar a imagem tira o banner do ar até a nova arte ser aprovada.": "Heads up: replacing the image takes the banner offline until the new artwork is approved.",
  "Ativo": "Active",
  "até {kb} KB — arquivos maiores deixam o carregamento do app lento": "up to {kb} KB — larger files slow the app down",
  "Avisaremos por e-mail antes do fim do período.": "We'll email you before the period ends.",
  "Ações": "Actions",
  "Bairro": "District",
  "Banner": "Banner",
  "Banner excluído com sucesso.": "Banner deleted.",
  "Banner na home do app": "Banner on the app home screen",
  "Banner na vitrine da home do Pertalks": "Banner in the Pertalks home showcase",
  "Banners": "Banners",
  "Banners de": "Banners for",
  "Banners no app": "In-app banners",
  "Buscar estabelecimento": "Search establishment",
  "Buscar por nome": "Search by name",
  "Busque e selecione o(s) estabelecimento(s) que você gerencia.": "Search for and select the establishment(s) you manage.",
  "Busque pelo nome e selecione o estabelecimento que você gerencia.": "Search by name and select the establishment you manage.",
  "Cadastrado em": "Registered on",
  "Cadastrado em {data}": "Registered on {data}",
  "cadastrar": "create",
  "Cadastrar": "Create",
  "Cadastrar banner": "Create banner",
  "Cadastrar cartão": "Add card",
  "Cadastrar meu estabelecimento": "Register my establishment",
  "Cadastre um cartão até {data} para continuar sem interrupção (R$ 29,90/mês). Aproveite para conhecer o plano Connection, com push, banners e destaque no mapa.": "Add a card by {data} to keep your access running (R$ 29.90/month). It's also a good time to look at the Connection plan, with push notifications, in-app banners and map highlighting.",
  "Cadastro em análise.": "Registration under review.",
  "Campanha atual": "Current campaign",
  "Campanhas anteriores": "Past campaigns",
  "Campo obrigatório": "Required field",
  "Cancelado": "Canceled",
  "Cancelar": "Cancel",
  "Cartão CNPJ:": "CNPJ card:",
  "Caso o seu estabelecimento não apareça no mapa Pertalks,": "If your establishment doesn't show up on the Pertalks map,",
  "Categoria": "Category",
  "CEP": "Postal code",
  "Check-in ativo": "Active check-in",
  "check-ins": "check-ins",
  "Cidade": "City",
  "clique aqui": "click here",
  "Clique em uma sugestão para preencher o texto. Você pode editar antes de enviar.": "Click a suggestion to fill in the text. You can edit it before sending.",
  "Clique ou arraste os arquivos aqui": "Click or drag your files here",
  "Clique para enviar os documentos": "Click to upload the documents",
  "Cliques na semana": "Clicks this week",
  "CNPJ do estabelecimento": "Establishment CNPJ",
  "CNPJ inválido. Confira o número digitado.": "Invalid CNPJ. Check the number you entered.",
  "Colaborador": "Employee",
  "Comece pelo que fizer sentido agora — dá para trocar quando quiser, na área de Assinatura.": "Start with whatever makes sense now — you can switch any time in the Subscription area.",
  "Como prefere ser chamado": "What you'd like to be called",
  "Complemento": "Apt. / Suite",
  "comprova a inscrição e a situação cadastral ativa do estabelecimento perante a Receita Federal.": "proves the establishment's registration and active status with the Receita Federal.",
  "comprova a inscrição e a situação cadastral ativa perante a Receita Federal.": "proves your registration and active status with the Receita Federal.",
  "Conecte-se com usuários que fizeram check-in": "Connect with users who checked in",
  "Confirmar nova senha": "Confirm new password",
  "Confirmar senha": "Confirm password",
  "Confirme a nova senha": "Confirm the new password",
  "Confirme o nome e endereço do estabelecimento no mapa": "Confirm the establishment's name and address on the map",
  "Confirme sua senha": "Confirm your password",
  "Conheça os nossos planos": "Explore our plans",
  "Conheça os planos Pulse e Wave": "Discover the Pulse and Wave plans",
  "Conta": "Account",
  "Conteúdo proibido:": "Prohibited content:",
  "Continuar": "Continue",
  "Coreano": "Korean",
  "Criando sua conta...": "Creating your account...",
  "Criar minha conta": "Create my account",
  "Criação de arte para banner": "Banner artwork request",
  "Crie sua conta": "Create your account",
  "Cumpra as missões para desbloquear benefícios.": "Complete missions to unlock benefits.",
  "Código": "Code",
  "Dados atualizados com sucesso.": "Details updated.",
  "Dados do estabelecimento": "Establishment details",
  "Dados e documentos da empresa (pessoa jurídica)": "Company details and documents (legal entity)",
  "Dados pessoais": "Personal details",
  "Dados pessoais do responsável pelo estabelecimento.": "Personal details of the person responsible for the establishment.",
  "Dashboard": "Dashboard",
  "Dashboard básico": "Basic dashboard",
  "Data": "Date",
  "Data de nascimento": "Date of birth",
  "DD/MM/AAAA": "DD/MM/YYYY",
  "DD/MM/YYYY [às] HH:mm": "DD/MM/YYYY [at] HH:mm",
  "Depois, R$ 29,90/mês": "Then R$ 29.90/mo",
  "Desconto exclusivo para você que está no app. Aproveite agora! 🏷️": "An exclusive discount for you, our app user. Grab it now! 🏷️",
  "desde {data}": "since {data}",
  "Destaque no mapa": "Map highlighting",
  "Destaque seu estabelecimento com": "Give your establishment",
  "Destaque visual no mapa Pertalks": "Visual highlight on the Pertalks map",
  "Dezembro": "December",
  "Dia": "Day",
  "Digite a mensagem do push": "Enter the push message",
  "Digite a nova senha": "Enter the new password",
  "Digite a url que o usuário deverá ser redirecionado ao clicar no banner": "Enter the URL users should be taken to when they tap the banner",
  "Digite ao menos 2 caracteres para buscar.": "Type at least 2 characters to search.",
  "Digite o código": "Enter the code",
  "Digite o código recebido por e-mail.": "Enter the code you received by email.",
  "Digite o nome do estabelecimento": "Enter the establishment name",
  "Digite seus dados para continuar.": "Enter your details to continue.",
  "Digite sua mensagem ou use uma sugestão acima…": "Type your message or pick a suggestion above…",
  "Digite sua senha": "Enter your password",
  "Digite um e-mail válido (ex.: nome@empresa.com.br).": "Enter a valid email (e.g. name@company.com).",
  "Digite um nome": "Enter a name",
  "Digite um título": "Enter a title",
  "Dimensões:": "Dimensions:",
  "Direitos autorais:": "Copyright:",
  "Disparar Notificação Push": "Send Push Notification",
  "disparo(s) extra(s) conquistado(s) em missões — valem até o fim deste mês.": "bonus send(s) earned from missions — valid through the end of this month.",
  "Disparos este mês · {publico}": "Sends this month · {publico}",
  "Disponível no Plano CONNECTION": "Available on the CONNECTION Plan",
  "Disponível nos Planos CONNECTION e SHOWCASE": "Available on the CONNECTION and SHOWCASE Plans",
  "Divulgação": "Online presence",
  "Divulgue sua marca na home do app": "Put your brand on the app home screen",
  "Documento de identificação:": "ID document:",
  "Documento obrigatório": "Required document",
  "Documentos": "Documents",
  "Documentos do estabelecimento": "Establishment documents",
  "Documentos do responsável pela abertura da conta": "Documents of the person opening the account",
  "Domingo": "Sunday",
  "e": "and",
  "E-mail": "Email",
  "editar": "edit",
  "Editar": "Edit",
  "Editar banner": "Edit banner",
  "Edite suas informações de perfil.": "Edit your profile information.",
  "Em análise": "In review",
  "Encontramos uma divergência nos documentos — verifique seu e-mail.": "We found a discrepancy in the documents — check your email.",
  "Encontramos uma divergência. Verifique seu e-mail — nossa equipe explicou o que precisa ser reenviado.": "We found a discrepancy. Check your email — our team explained what you need to resend.",
  "Endereço": "Address",
  "Endereço completo:": "Full address:",
  "Engaje seus clientes para que façam check-in no app da Pertalks e tenha dados relevantes do público que frequenta o seu estabelecimento!": "Get your customers to check in on the Pertalks app and gain meaningful data about the people who visit your establishment!",
  "Enquadre seu rosto e o documento juntos": "Fit your face and the document in the frame together",
  "Enquanto isso, o restante do painel continua disponível.": "In the meantime, the rest of the panel stays available.",
  "Entrar": "Sign in",
  "Entrar e cadastrar cartão": "Sign in and add card",
  "Entre em contato com a equipe Pertalks para cadastrar seu estabelecimento.": "Contact the Pertalks team to register your establishment.",
  "entre em contato com a Pertalks": "get in touch with Pertalks",
  "Entre em contato conosco": "Get in touch",
  "entregue(s)": "delivered",
  "Enviando cadastro e documentos...": "Submitting your registration and documents...",
  "Enviando documentos... ({atual}/{total})": "Uploading documents... ({atual}/{total})",
  "Enviando para clientes de": "Sending to customers of",
  "Enviando...": "Uploading...",
  "Enviando…": "Sending…",
  "Enviar cadastro": "Submit registration",
  "Enviar documentos": "Upload documents",
  "Enviar mensagem": "Send message",
  "Enviar notificação": "Send notification",
  "Enviar um arquivo": "Upload a file",
  "Envie a selfie segurando seu documento.": "Upload the selfie holding your ID.",
  "Envie ao menos um documento.": "Upload at least one document.",
  "Envie o Cartão CNPJ de \"{nome}\" para análise.": "Upload the CNPJ card for \"{nome}\" for review.",
  "Envie os documentos abaixo para que possamos validar seu cadastro.": "Upload the documents below so we can verify your registration.",
  "Envie promoções, novidades e muito mais aos usuários que frequentam seu estabelecimento.": "Send promos, news and more to the users who visit your establishment.",
  "Envie uma foto sua segurando seu documento de identificação (RG ou CNH). Usamos essa imagem apenas para confirmar sua identidade.": "Upload a photo of yourself holding your ID (national ID or driver's license). We only use this image to confirm your identity.",
  "Envie uma nova imagem abaixo. Não há limite de tentativas e o prazo contratado só começa a contar depois da aprovação.": "Upload a new image below. There's no limit on attempts, and the period you paid for only starts counting after approval.",
  "Envio de notificações push personalizadas para usuários que fizeram check-in": "Custom push notifications to users who checked in",
  "Erro ao abrir portal de pagamento.": "Couldn't open the billing portal.",
  "Erro ao carregar banner.": "Error loading banner.",
  "Erro ao carregar banners.": "Couldn't load your banners.",
  "Erro ao carregar dados da assinatura.": "Couldn't load your subscription data.",
  "Erro ao carregar dashboard.": "Could not load the dashboard.",
  "Erro ao carregar estabelecimentos.": "Couldn't load your establishments.",
  "Erro ao carregar estatísticas.": "Couldn't load your stats.",
  "Erro ao enviar notificação.": "Couldn't send the notification.",
  "Erro ao iniciar checkout.": "Couldn't start checkout.",
  "Escolha seu vínculo com o estabelecimento.": "Choose your relationship with the establishment.",
  "Espanhol": "Spanish",
  "espaço premium": "premium space",
  "Esqueci a senha": "Forgot my password",
  "Estabelecimento": "Establishment",
  "Estabelecimento já cadastrado — {nome}": "Establishment already registered — {nome}",
  "Estabelecimentos": "Establishments",
  "Estamos analisando os documentos": "We're reviewing your documents",
  "Estamos analisando os documentos de {nome}": "We're reviewing the documents for {nome}",
  "Estatísticas avançadas de comportamento e retorno do público": "Advanced stats on audience behavior and repeat visits",
  "Estatísticas de retorno do público": "Audience return stats",
  "Este e-mail já está sendo usado.": "This email is already in use.",
  "Estou ciente que meus dados serão removidos e desejo excluir minha conta.": "I understand my data will be removed and I want to delete my account.",
  "Evento especial acontecendo agora no nosso espaço. Você está a poucos passos! 🎶": "A special event is happening at our place right now. You're just steps away! 🎶",
  "Evite reflexos, sombras fortes e imagens tremidas": "Avoid glare, harsh shadows and blurry shots",
  "Ex.: Agência Criativa": "E.g.: Creative Agency",
  "Ex.: Gerente de marketing": "E.g.: Marketing manager",
  "Ex: Oferta especial!": "e.g. Special offer!",
  "Excluir": "Delete",
  "Excluir banner": "Delete banner",
  "Excluir conta": "Delete account",
  "Expirado": "Expired",
  "Exportar relatório": "Export report",
  "fale com o suporte": "talk to support",
  "Falha ao enviar os documentos.": "Failed to upload the documents.",
  "Falta cadastrar seu cartão.": "You still need to add your card.",
  "Fazer upgrade para Connection": "Upgrade to Connection",
  "Fechar": "Close",
  "Fevereiro": "February",
  "Filtrar": "Filter",
  "Filtrar interesses": "Filter interests",
  "Formato inválido. Envie um arquivo {formatos}.": "Invalid format. Upload a {formatos} file.",
  "Formato:": "Format:",
  "Francês": "French",
  "Gerenciar assinatura": "Manage subscription",
  "Gestão de banners promocionais": "Promotional banner management",
  "Grátis": "Free",
  "Hindi": "Hindi",
  "Histórico de pagamentos": "Payment history",
  "Hoje tem promoção imperdível. Aproveite enquanto durar! ⚡": "Today's deal is too good to miss. Enjoy it while it lasts! ⚡",
  "Horário": "Time",
  "Horários de pico": "Peak hours",
  "ID da sessão: {id}": "Session ID: {id}",
  "Ideia / mensagem que quero transmitir:": "Idea / message I want to get across:",
  "Identificação de tendências de comportamento dos clientes": "Spot trends in how your customers behave",
  "Imagem do banner": "Banner image",
  "imagens agressivas, com nudez ou gestos obscenos não são aprovadas": "violent images, nudity, or obscene gestures won't be approved",
  "Inclui": "Includes",
  "Incompleto": "Incomplete",
  "Informações salvas com sucesso.": "Information saved successfully.",
  "Informe a cidade.": "Enter the city.",
  "Informe o assunto": "Enter the subject",
  "Informe o bairro.": "Enter the district.",
  "Informe o CEP.": "Enter the postal code.",
  "Informe o CNPJ do estabelecimento.": "Enter the establishment's CNPJ.",
  "Informe o endereço.": "Enter the address.",
  "Informe o estado (UF).": "Enter the state.",
  "Informe o nome da agência.": "Enter the agency name.",
  "Informe o número.": "Enter the number.",
  "Informe o texto da mensagem.": "Enter the message text.",
  "Informe seu e-mail": "Enter your email",
  "Informe seu e-mail.": "Enter your email.",
  "Informe seu nome completo.": "Enter your full name.",
  "Informe seu usuário para receber o código.": "Enter your username to receive the code.",
  "Informe sua função no estabelecimento.": "Enter your role at the establishment.",
  "Informe sua senha para confirmar.": "Enter your password to confirm.",
  "Informe um título.": "Enter a title.",
  "Inglês": "English",
  "Insights do momento": "Live insights",
  "Instagram": "Instagram",
  "Ir para pagamento": "Go to payment",
  "Italiano": "Italian",
  "Janeiro": "January",
  "Japonês": "Japanese",
  "JPG ou PNG — no máximo 10 MB": "JPG or PNG — 10 MB max",
  "JPG, PNG ou WebP": "JPG, PNG or WebP",
  "Julho": "July",
  "Junho": "June",
  "Já cadastrado": "Already registered",
  "Já fez check-in": "Checked in before",
  "Já tem conta?": "Already have an account?",
  "já visitaram": "past visitors",
  "liberado sem custo até": "free until",
  "Liberar estabelecimento no Pertalks": "Enable my establishment on Pertalks",
  "Limite mensal atingido": "Monthly limit reached",
  "Limite mensal de disparos atingido.": "You've hit your monthly send limit.",
  "Limpar seleção": "Clear selection",
  "Linguagem nativa": "Native language",
  "Link direto para o seu perfil": "Direct link to your profile",
  "Link direto para seu perfil": "Direct link to your profile",
  "Maio": "May",
  "Maior alcance": "Wider reach",
  "Mais completo": "Most complete",
  "Mais popular": "Most popular",
  "Mandarim": "Mandarin",
  "mantenha textos e logos centralizados, para não serem cortados em telas menores": "keep text and logos centered so they don't get cropped on smaller screens",
  "Marque a confirmação para excluir a conta.": "Check the confirmation box to delete your account.",
  "Março": "March",
  "Melhores dias e horários": "Best days and times",
  "Mensagem": "Message",
  "Meu perfil": "My profile",
  "Meu Perfil": "My Profile",
  "Meus Estabelecimentos": "My Establishments",
  "Mínimo 8 caracteres": "At least 8 characters",
  "Nenhum dado disponível.": "No data available.",
  "Nenhum estabelecimento cadastrado": "No establishments registered",
  "Nenhum estabelecimento encontrado nesta área. Mova o mapa ou aumente o raio.": "No establishments found in this area. Move the map or widen the radius.",
  "Nenhum estabelecimento encontrado para \"{termo}\".": "No establishments found for \"{termo}\".",
  "Nenhum plano disponível no momento.": "No plans available right now.",
  "Nenhum resultado para \"{termo}\".": "No results for \"{termo}\".",
  "Nenhum usuário ativo no momento": "No active users right now",
  "Nenhuma assinatura ativa para exibir pagamentos.": "No active subscription, so there are no payments to show.",
  "Nenhuma campanha anterior": "No past campaigns",
  "Nenhuma cobrança foi realizada.": "No charge was made.",
  "Nenhuma câmera encontrada. Envie um arquivo pelo botão abaixo.": "No camera found. Upload a file using the button below.",
  "Nenhuma missão ativa no momento.": "No active missions right now.",
  "no app.": "in the app.",
  "No ar": "Live",
  "no local agora": "at the establishment now",
  "No momento não há usuários ativos para receber a notificação. Tente novamente mais tarde.": "There are no active users to receive this notification right now. Try again later.",
  "Nome": "Name",
  "Nome completo": "Full name",
  "Nome da agência": "Agency name",
  "Nome do estabelecimento:": "Establishment name:",
  "Nome e Sobrenome": "First and last name",
  "Nossa equipe avalia em até 72 horas. Se você trocar a imagem agora, a análise recomeça do zero.": "Our team reviews it within 72 hours. If you replace the image now, the review starts over.",
  "Nossa equipe irá avaliar os documentos enviados. O prazo é de até 48 horas. Após a aprovação, sua assinatura estará disponível.": "Our team will review the documents you sent. It takes up to 48 hours. Once approved, your subscription will be available.",
  "Notificações": "Notifications",
  "Notificações Push": "Push Notifications",
  "Notificações push": "Push notifications",
  "Nova mensagem": "New message",
  "Nova senha": "New password",
  "Nova Senha": "New password",
  "Novembro": "November",
  "Novidade no cardápio hoje! Não perca essa experiência única. 🍽️": "Something new on the menu today! Don't miss out on this one. 🍽️",
  "Novos": "New",
  "Nº": "No.",
  "Não cubra o rosto nem os dados com os dedos . Não usar boné, óculos ou nenhum outro tipo de acessório.": "Don't cover your face or the details with your fingers. No caps, glasses or any other accessories.",
  "Não foi possível abrir a câmera. Envie um arquivo pelo botão abaixo.": "We couldn't open the camera. Upload a file using the button below.",
  "Não foi possível adicionar o estabelecimento.": "Couldn't add the establishment.",
  "Não foi possível excluir o banner. Por favor, tente novamente.": "We couldn't delete the banner. Please try again.",
  "Não foi possível ler a imagem.": "We couldn't read the image.",
  "Não foi possível salvar as informações. Por favor, tente novamente.": "We couldn't save your information. Please try again.",
  "Não foi possível salvar. Tente novamente.": "Couldn't save. Try again.",
  "não inclua selos inventados (ex.: \"O melhor do app\") nem preços que não condizem com o cardápio": "don't add made-up badges (e.g. \"Best on the app\") or prices that don't match your menu",
  "Não informado": "Not provided",
  "Não Pago": "Unpaid",
  "não use imagens do Google, logos de outras marcas ou fotos de terceiros sem autorização": "don't use images from Google, other brands' logos, or third-party photos without permission",
  "Número": "Number",
  "Número de Meets": "Number of Meets",
  "O envio de notificações push personalizadas é uma funcionalidade exclusiva do plano": "Sending custom push notifications is a feature exclusive to",
  "O prazo é de até": "It takes up to",
  "O prazo é de até 72 horas. Seu painel já está liberado normalmente.": "It takes up to 72 hours. Your dashboard is already fully available.",
  "o texto não deve ocupar mais de 20% da imagem": "text shouldn't take up more than 20% of the image",
  "Ocorreu um erro. Tente novamente.": "Something went wrong. Try again.",
  "Olá! Estou no cadastro do meu estabelecimento no Pertalks (passo {passo}) e preciso de ajuda.": "Hi! I'm signing up my establishment on Pertalks (step {passo}) and I need help.",
  "Olá! Gostaria de saber mais sobre raios e períodos personalizados no plano {plano}.": "Hi! I'd like to know more about custom reach and run times on the {plano} plan.",
  "Olá! Gostaria que o time Pertalks criasse a arte do meu banner.": "Hi! I'd like the Pertalks team to create the artwork for my banner.",
  "Olá! Meu estabelecimento não aparece no mapa Pertalks.": "Hi! My establishment doesn't show up on the Pertalks map.",
  "Olá! Preciso de ajuda com a plataforma Pertalks.": "Hi! I need help with the Pertalks platform.",
  "Olá! Tentei cadastrar o estabelecimento \"{nome}\" mas ele já está vinculado a outro usuário. Sou o responsável por este local e gostaria de regularizar o acesso.": "Hi! I tried to register the establishment \"{nome}\" but it is already linked to another user. I'm the person responsible for this place and I'd like to sort out my access.",
  "Olá, como vai?": "Hello, how are you?",
  "Opcional — deixe em branco se o banner não leva a lugar nenhum": "Optional — leave blank if the banner doesn't link anywhere",
  "Ordenação": "Order",
  "Os arquivos somados ficaram grandes demais para o envio. Remova algum documento ou envie fotos menores e tente de novo.": "Your files are too large to upload together. Remove a document or send smaller photos and try again.",
  "Os dados do documento precisam estar legíveis": "The details on the document must be readable",
  "ou": "or",
  "Outros": "Other",
  "Outubro": "October",
  "Pagamento cancelado": "Payment canceled",
  "Pagamento Pendente": "Payment Pending",
  "Pagamentos": "Payments",
  "Para a foto ser aprovada:": "For the photo to be approved:",
  "para este público neste mês. O limite será renovado no dia 1 do próximo mês.": "for this audience this month. The limit resets on the 1st of next month.",
  "para nos enviar um email com o nome e endereço completo do seu estabelecimento para que possamos liberar a sua categoria em nosso sistema.": "to send us an email with your establishment's name and full address so we can enable your category in our system.",
  "Para raios e períodos personalizados,": "For a custom reach or run time,",
  "Para sugestões, dúvidas ou outras informações, entre em contato conosco pelo formulário abaixo.": "For suggestions, questions or anything else, get in touch using the form below.",
  "Para trocar, use o seletor no Dashboard.": "To switch, use the selector on the Dashboard.",
  "Participe ativamente das conexões geradas no app": "Take an active part in the connections made in the app",
  "Passo {n} de {total}": "Step {n} of {total}",
  "PDF, JPG ou PNG": "PDF, JPG or PNG",
  "PDF, JPG, PNG — múltiplos arquivos permitidos": "PDF, JPG, PNG — multiple files allowed",
  "Pendente": "Pending",
  "Pendentes": "Pending",
  "Perfeito para entender seus clientes": "Perfect for getting to know your customers",
  "Período de Teste": "Trial Period",
  "Período:": "Period:",
  "Período: {inicio} → {fim}": "Period: {inicio} → {fim}",
  "Peso do arquivo:": "File size:",
  "Pesquisar nesta área": "Search this area",
  "Pesquisar...": "Search...",
  "Pesquise pelo endereço ou nome do estabelecimento": "Search by address or establishment name",
  "Plano": "Plan",
  "Plano atual": "Current plan",
  "Plano Connection": "Connection plan",
  "Plano personalizado — {plano}": "Custom plan — {plano}",
  "Plano Pulse": "Pulse plan",
  "Plano Wave": "Wave plan",
  "Planos": "Plans",
  "Poderiam liberar a categoria no sistema?": "Could you enable the category in the system?",
  "Português Brasileiro": "Brazilian Portuguese",
  "Português Europeu": "European Portuguese",
  "Prazo desejado:": "Desired deadline:",
  "Precisa de ajuda?": "Need help?",
  "Precisamos da permissão de câmera. Libere o acesso nas configurações do navegador ou envie um arquivo.": "We need camera permission. Allow access in your browser settings or upload a file instead.",
  "Precisamos de um ajuste nos seus documentos": "We need a small fix to your documents",
  "Preencha a senha atual e a nova senha.": "Enter your current password and the new one.",
  "Preencha as informações abaixo para {acao} um banner. Ele será exibido na página do estabelecimento.": "Fill in the details below to {acao} a banner. It will be shown on your establishment's page.",
  "Preview": "Preview",
  "Principais assuntos e interesses": "Top topics and interests",
  "Principais interesses do público": "Top audience interests",
  "Prioridade de exibição na vitrine": "Priority placement in the showcase",
  "Prioridade máxima no suporte": "Top-priority support",
  "Prioridade na vitrine": "Priority in the showcase",
  "Procurar": "Browse",
  "Proprietário": "Owner",
  "Pré check-in para usuários": "Pre check-in for users",
  "Pré-visualização da selfie": "Selfie preview",
  "Próxima": "Next",
  "Próximo": "Next",
  "Qual plano combina com você?": "Which plan fits you?",
  "Quarta-feira": "Wednesday",
  "Que tal um mimo especial? Venha buscar a sua surpresa! 🎁": "How about a little treat? Come pick up your surprise! 🎁",
  "quem está no local": "at the establishment now",
  "Quem está no local agora": "People at your establishment now",
  "Quem já visitou": "People who've visited",
  "quem já visitou": "past visitors",
  "Quer ainda mais vantagens? Com o Connection você envia notificações push, publica banners no app e ganha destaque no mapa.": "Want even more? With Connection you send push notifications, publish banners in the app and get highlighted on the map.",
  "Quer que o time Pertalks crie as artes para você?": "Want the Pertalks team to create your artwork?",
  "Quinta-feira": "Thursday",
  "Recorrentes": "Returning",
  "Recuperar senha": "Recover password",
  "Recurso disponível apenas no plano Connection.": "This feature is only available on the Connection plan.",
  "Redefinir senha": "Set new password",
  "Redirecionando em {segundos}s…": "Redirecting in {segundos}s…",
  "Refazer foto": "Retake photo",
  "Regra da missão: {title}": "Mission rule: {title}",
  "Remover": "Remove",
  "Remover imagem": "Remove image",
  "Repita a nova senha": "Repeat the new password",
  "Repita a Senha": "Repeat password",
  "Repita a senha": "Repeat the password",
  "Repostar": "Repost",
  "Repostar banner": "Repost banner",
  "RG, CNH ou passaporte válido.": "National ID, driver's license or valid passport.",
  "Rua, Av...": "Street, Ave...",
  "Russo": "Russian",
  "Sair": "Log out",
  "Salvar": "Save",
  "Se você tem outra unidade já aprovada, troque no seletor do Dashboard para disparar por ela normalmente.": "If you have another location already approved, switch to it in the Dashboard selector and send from there as usual.",
  "Se você tem outra unidade já aprovada, troque no seletor do Dashboard para usar os banners dela normalmente.": "If you have another location already approved, switch to it in the Dashboard selector and use its banners as usual.",
  "Segunda-feira": "Monday",
  "Selecionados:": "Selected:",
  "Selecionar": "Select",
  "Selecionar idioma": "Select a language",
  "Selecionar no mapa": "Pick on the map",
  "Selecionar todos": "Select all",
  "Selecione": "Select",
  "Selecione a categoria": "Select a category",
  "Selecione a data final": "Select the end date",
  "Selecione a data inicial": "Select the start date",
  "Selecione ao menos um estabelecimento.": "Select at least one establishment.",
  "Selecione um estabelecimento.": "Select an establishment.",
  "Selfie com documento": "Selfie with your ID",
  "Selo de destaque no app": "Featured badge in the app",
  "Selo de Local Seguro": "Safe Place badge",
  "Sem cartão": "No card needed",
  "Sem dados": "No data",
  "Sem dados para o período selecionado": "No data for the selected period",
  "Sem promessas falsas:": "No false claims:",
  "Senha": "Password",
  "Senha atual": "Current password",
  "Será enviado para {n} pessoa(s) que já visitaram seu estabelecimento": "Will be sent to {n} people who have already visited your establishment",
  "Será enviado para {n} usuário(s) com check-in ativo": "Will be sent to {n} user(s) with an active check-in",
  "Setembro": "September",
  "Seu cadastro está em análise. Prazo: até 48 horas.": "Your registration is under review. It takes up to 48 hours.",
  "Seu documento pessoal já foi validado no cadastro — não precisa reenviar.": "Your personal ID was already verified at sign-up — no need to send it again.",
  "Seu estabelecimento": "Your establishment",
  "Seu navegador não permite usar a câmera aqui. Envie um arquivo pelo botão abaixo.": "Your browser won't let us use the camera here. Upload a file using the button below.",
  "Seu nome completo": "Your full name",
  "Seu pagamento foi processado com sucesso.": "Your payment went through.",
  "Seu período gratuito termina em {dias} dia(s)": "Your free trial ends in {dias} day(s)",
  "Seu rosto e o documento devem aparecer juntos, na mesma foto": "Your face and the document must appear together, in the same photo",
  "Seu vínculo com o estabelecimento": "Your relationship with the establishment",
  "seu@email.com": "you@email.com",
  "seu_perfil": "your_handle",
  "Seus documentos estão em análise": "Your documents are under review",
  "Seus documentos serão analisados em até": "Your documents will be reviewed within",
  "Seus documentos serão analisados em até 72 horas, mas seu painel é liberado imediatamente.": "Your documents will be reviewed within 72 hours, but your dashboard is available right away.",
  "Sexta-feira": "Friday",
  "Site": "Website",
  "Solicitar novo código": "Request a new code",
  "Solicitar troca de senha": "Request password reset",
  "Status": "Status",
  "Sua arte precisa de ajuste": "Your artwork needs changes",
  "Sua assinatura já está ativa na plataforma Pertalks.": "Your subscription is already active on Pertalks.",
  "Sua conta já está ativa. É só entrar e começar a acompanhar os check-ins do seu estabelecimento.": "Your account is already active. Just sign in and start tracking the check-ins at your establishment.",
  "Sua conta não tem acesso a este painel. Use o aplicativo Pertalks.": "Your account doesn't have access to this panel. Please use the Pertalks app.",
  "Sua função no estabelecimento": "Your role at the establishment",
  "Sugestões Pertalks": "Pertalks suggestions",
  "Suporte": "Support",
  "Suporte no WhatsApp": "WhatsApp support",
  "Suporte por e-mail": "Email support",
  "Suporte prioritário": "Priority support",
  "Suporte prioritário via WhatsApp": "Priority support on WhatsApp",
  "Sábado": "Saturday",
  "são liberadas após a aprovação dos documentos.": "areas unlock once your documents are approved.",
  "Tamanho 420x150px. JPG ou PNG": "Size 420x150px. JPG or PNG",
  "Tarefas": "Tasks",
  "Tarefas que desbloqueiam benefícios, descontos e muito mais!": "Tasks that unlock perks, discounts and much more!",
  "Tem certeza que deseja excluir este banner?": "Are you sure you want to delete this banner?",
  "Temos uma oferta especial esperando por você! Venha nos visitar agora. 🎉": "We have a special offer waiting for you! Come visit us now. 🎉",
  "Tempo médio de permanência": "Average time on site",
  "Tentar novamente": "Try again",
  "Terça-feira": "Tuesday",
  "Texto deve ter no máximo {max} caracteres.": "The message can't be longer than {max} characters.",
  "Texto excede o limite de {max} caracteres.": "The text is over the {max}-character limit.",
  "Textos curtos:": "Short text:",
  "Tirar foto agora": "Take a photo now",
  "Todas as vantagens do plano Insight": "Everything in the Insight plan",
  "Todos os dias": "All days",
  "Top 10 Assuntos/Interesses": "Top 10 Topics/Interests",
  "Top 10 Idiomas": "Top 10 Languages",
  "Top 5 Assuntos": "Top 5 Topics",
  "Top 5 Idiomas": "Top 5 Languages",
  "Total de check-ins": "Total check-ins",
  "Total de cliques": "Total clicks",
  "Tudo do Insight": "Everything in Insight",
  "Tudo do Pulse": "Everything in Pulse",
  "Tudo do Showcase Pulse": "Everything in Showcase Pulse",
  "Tudo pronto! Seu painel já está liberado": "All set! Your dashboard is ready",
  "Título": "Title",
  "Título (opcional)": "Title (optional)",
  "UF": "State",
  "Um dos estabelecimentos já está vinculado a outro usuário.": "One of the establishments is already linked to another user.",
  "Uma das suas artes precisa de ajuste. Veja o motivo na coluna": "One of your artworks needs changes. See why under",
  "URL": "URL",
  "Usuário": "Username",
  "Usuários online": "Users online",
  "Usuários recorrentes": "Returning users",
  "Validar código": "Validate code",
  "Veiculação de 15 dias": "15 days of exposure",
  "Veiculação de 30 dias": "30 days of exposure",
  "Ver assinaturas": "View subscriptions",
  "Ver detalhes": "View details",
  "Ver faturas & pagamentos": "View invoices & payments",
  "Ver mais planos": "See more plans",
  "Ver minha assinatura": "View my subscription",
  "Ver planos anteriores": "See previous plans",
  "Ver planos disponíveis": "See available plans",
  "Você ainda não possui um plano ativo": "You don't have an active plan yet",
  "Você atingiu o limite de": "You've reached your limit of",
  "Você cancelou o processo de pagamento.": "You canceled the payment.",
  "Você tem acesso ao espaço premium de divulgação no app. Acompanhe o desempenho das suas campanhas.": "You have access to premium promo space in the app. Keep track of how your campaigns are doing.",
  "Você tem arte em análise. Nossa equipe avalia em até": "You have artwork in review. Our team gets to it in up to",
  "Voltar": "Back",
  "Voltar ao dashboard": "Back to dashboard",
  "Vínculo não identificado. Feche e tente novamente.": "We couldn't identify this link. Close and try again.",
  "www.exemplo.com.br": "www.example.com",
  "Zona de segurança:": "Safe zone:",
  "{count} usuários": "{count} users",
  "{current} de {target}": "{current} of {target}",
  "{inicio} a {fim}": "{inicio} to {fim}",
  "{n} de {total} disparos · {pessoas} pessoa(s)": "{n} of {total} sends · {pessoas} people",
  "{n} disparo(s) extra(s) disponível(is)": "{n} extra push(es) available",
  "{n} disparo(s) restante(s) este mês": "{n} send(s) left this month",
  "{n} disparos": "{n} sends",
  "{n} notificação(ões) enviada(s) com sucesso!": "{n} notification(s) sent successfully!",
  "{n} notificação(ões) enviada(s). {falhas} não chegaram (aparelho sem o app ou notificações desativadas).": "{n} notification(s) sent. {falhas} didn't arrive (app not installed or notifications turned off).",
  "{pct}% de desconto na próxima fatura": "{pct}% off your next invoice",
  "{v} banner(s) sem custo": "{v} free banner(s)",
  "{v} disparo(s) extra(s) de notificação": "{v} extra push notification(s)",
  "{v}% de desconto na próxima mensalidade": "{v}% off your next monthly bill",
  "{w}x{h}px (exatamente esse tamanho)": "{w}x{h}px (exactly this size)",
  "Árabe": "Arabic",
  "Último envio:": "Last send:",
  "✓ Selecionado": "✓ Selected",
  "📋 Especificações técnicas": "📋 Technical specifications",
  "📸 Capturar foto": "📸 Take photo",
  "🚫 Diretrizes de conteúdo": "🚫 Content guidelines",
};